import { defineStore } from 'pinia';

import { storeToRefs } from 'pinia';
import { HC } from '@/components/ueModel/js/HC';
import { Data } from '@/components/ueModel/js/Data';
import { useOverViewStore } from '@/store/overView/index';

export const usePageEvents = defineStore('usePageEvents', {
  /**
   * 存储全局状态
   * 1.必须是箭头函数: 为了在服务器端渲染的时候避免交叉请求导致数据状态污染
   * 和 TS 类型推导
   */
  state: () => {
    return {
      eventsBtns: [
        {
          name: '产位优势',
          pageIndex: 0,
          icon: require('@/assets/images/ueModel/eventsBtn/advantage.png'),
          isShow: true,
          start: () => {
            console.log('*****产位优势');
          },
          end: () => {
            console.log('清除**产位优势');
          },
        },
        {
          name: '交通区位',
          pageIndex: 0,
          icon: require('@/assets/images/ueModel/eventsBtn/traffic.png'),
          isShow: true,
          start: () => {
            console.log('*****交通区位');
          },
          end: () => {
            console.log('清除**交通区位');
          },
        },
        {
          name: '周边配套',
          pageIndex: 0,
          icon: require('@/assets/images/ueModel/eventsBtn/energy.png'),
          isShow: true,
          start: () => {
            console.log('*****周边配套');
          },
          end: () => {
            console.log('清除**周边配套');
          },
        },
        {
          name: '主楼展开',
          pageIndex: 1,
          icon: require('@/assets/images/ueModel/eventsBtn/building.png'),
          isShow: true,
          start: () => {
            console.log('*****主楼展开');
            let thisEvents = usePageEvents();
            const { floorData, timer } = storeToRefs(thisEvents);

            HC.eventControl.CmdSplitBuilding(true);
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.floorCamera);
            clearTimeout(timer.value);

            floorData.value.isShow = true;

            thisEvents = null;
          },
          end: () => {
            console.log('清除**主楼展开');
            let thisEvents = usePageEvents();
            const { floorData, timer } = storeToRefs(thisEvents);
            floorData.value.selIndex = null;
            floorData.value.isShow = false;
            floorData.value.anlysIshow = false;
            thisEvents = null;
            HC.eventControl.CmdSplitBuilding(false);
            clearTimeout(timer.value);
          },
        },
        {
          name: '园区时间线',
          pageIndex: 1,
          icon: require('@/assets/images/ueModel/eventsBtn/time.png'),
          isShow: true,
          start: () => {
            console.log('*****园区时间线');
            let thisEvents = usePageEvents();
            // const { timeLine } = storeToRefs(thisEvents);
            // timeLine.value.index = 0;
            // thisEvents = null;
            HC.eventControl.CmdPlayActionByFileName('园区时间线开始');
          },
          end: () => {
            console.log('清除**园区时间线');
            let thisEvents = usePageEvents();
            const { timeLine } = storeToRefs(thisEvents);
            timeLine.value.index = null;
            thisEvents = null;
            HC.eventControl.CmdPlayActionByFileName('园区时间线恢复');
          },
        },
        {
          name: '楼宇信息',
          pageIndex: 1,
          icon: require('@/assets/images/ueModel/eventsBtn/lou.png'),
          isShow: true,
          start: () => {
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.buildInfomation);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['楼栋标牌']);
            console.log('*****楼宇信息');
          },
          end: () => {
            console.log('清除**楼宇信息');
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, ['楼栋标牌']);
            HC.eventControl.CmdBuildInfoClear();
          },
        },
        {
          name: '楼层信息',
          pageIndex: 1,
          icon: require('@/assets/images/ueModel/eventsBtn/floor.png'),
          isShow: true,
          start: () => {
            console.log('*****楼层信息');
          },
          end: () => {
            console.log('清除**楼层信息');
          },
        },
        {
          name: '明星企业',
          pageIndex: 2,
          icon: require('@/assets/images/ueModel/eventsBtn/star.png'),
          isShow: true,
          start: () => {
            console.log('*****明星企业分布');
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.startOperation);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['公司名称']);
          },
          end: () => {
            console.log('清除**明星企业分布');
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, ['公司名称']);
            HC.eventControl.CmdPlayActionByFileName('1号楼拆楼打点复原');
          },
        },
        {
          name: '楼宇能耗',
          pageIndex: 3,
          icon: require('@/assets/images/ueModel/eventsBtn/energy.png'),
          isShow: true,
          start: () => {
            console.log('*****楼宇能耗');
            HC.eventControl.CmdEnergy(true);
          },
          end: () => {
            console.log('清除**楼宇能耗');
            HC.eventControl.CmdEnergy(false);
          },
        },
        {
          name: '动环设备',
          icon: require('@/assets/images/ueModel/eventsBtn/device.png'),
          pageIndex: 5,
          isShow: true,
          start: () => {
            console.log('*****动环设备');
            HC.eventControl.CmdWarning(true);
          },
          end: () => {
            console.log('清除**动环设备');
            HC.eventControl.CmdWarning(false);
          },
        },
        {
          name: '配电房',
          pageIndex: 5,
          icon: require('@/assets/images/ueModel/eventsBtn/electric.png'),
          isShow: true,
          start: () => {
            console.log('*****配电房');
            HC.eventControl.CmdElectric(true);
          },
          end: () => {
            console.log('清除**配电房');
            HC.eventControl.CmdElectric(false);
          },
        },
        {
          name: '电梯',
          pageIndex: 5,
          icon: require('@/assets/images/ueModel/eventsBtn/elevator.png'),
          isShow: true,
          start: () => {
            console.log('*****电梯');
            HC.eventControl.CmdPlayActionByFileName('开始电梯动画');
          },
          end: () => {
            console.log('清除**电梯');
            HC.eventControl.CmdPlayActionByFileName('复原电梯动画');
          },
        },
      ],
      timeLine: {
        index: null,
        data: [
          {
            name: '2020',
            id: 0,
            content: '园区时间线2020',
            text: '灏安生物大厦落成，园区开始有规划的投入建设',
          },
          {
            name: '2022',
            id: 1,
            content: '园区时间线2022',
            text: '冠粤路桥建成 、广东省珠宝玉石交易中心对外开放。标志着园区开始形式建设加速。',
          },
          {
            name: '2023',
            id: 2,
            content: '园区时间线2023',
            text: '番禺节能创新园、信息产业中心落成。园区配套日渐完善，形成一定的产业规模和产业配套。',
          },
          {
            name: '未来',
            id: 3,
            content: '园区时间线未来',
            text: '按规划陆续建设，将番禺工业经济总部园区打造成为智造创新城。',
          },
        ],
      },
      floorData: {
        selIndex: null,
        isShow: false,
        data: [
          // {
          //   id: "15",
          //   name: "16楼",
          //   camera: {
          //     Location: {
          //       X: 21254.020522,
          //       Y: 7778.99183,
          //       Z: 25697.21827,
          //     },
          //     Rotation: {
          //       Pitch: -44.337555,
          //       Yaw: -129.561376,
          //       Roll: 0.0,
          //     },
          //   },
          // },
          {
            id: '14',
            name: '15楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '13',
            name: '14楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '12',
            name: '13楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '11',
            name: '12楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '10',
            name: '11楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '9',
            name: '10楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '8',
            name: '9楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '7',
            name: '8楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '6',
            name: '7楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '5',
            name: '6楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '4',
            name: '5楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '3',
            name: '4楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '2',
            name: '3楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '1',
            name: '2楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
          {
            id: '0',
            name: '1楼',
            camera: {
              Location: {
                X: 30497.68169,
                Y: 3543.998604,
                Z: 36849.639358,
              },
              Rotation: {
                Pitch: -38.949265,
                Yaw: -135.217387,
                Roll: 0.0,
              },
            },
          },
        ],
      },
      timer: null,
      poiBtns: [
        {
          name: '监控',
          pageIndex: 4,
          isShow: true,
          start: () => {
            console.log('*****监控');
            let overView = useOverViewStore();
            const { monitoringIndex } = storeToRefs(overView);
            monitoringIndex.value = 0;

            HC.CameraControl.CmdMoveCamera(Data.eventCamera.monitor);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['摄像头']);
          },
          end: () => {
            console.log('清除**监控');
            let overView = useOverViewStore();
            const { monitoringIndex } = storeToRefs(overView);
            monitoringIndex.value = null;
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, [
              '摄像头',
              '枪式摄像头',
              '球形摄像头',
              '鹰眼摄像头',
            ]);
          },
        },
        {
          name: '门禁',
          pageIndex: 4,
          isShow: true,
          start: () => {
            console.log('*****门禁');
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.door);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['门禁']);
          },
          end: () => {
            console.log('清除**门禁');
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, ['门禁']);
          },
        },
        {
          name: '道闸',
          pageIndex: 4,
          isShow: true,
          start: () => {
            console.log('*****道闸');
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.camp);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['道闸']);
          },
          end: () => {
            console.log('清除**道闸');
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, ['道闸']);
          },
        },
        {
          name: '巡更',
          pageIndex: 4,
          isShow: true,
          start: () => {
            console.log('*****人员');
            HC.CameraControl.CmdMoveCamera(Data.eventCamera.person);
            HC.poiControl.CmdSwitchPoi2DByTemplates(true, ['人员']);
          },
          end: () => {
            console.log('清除**人员');
            HC.poiControl.CmdSwitchPoi2DByTemplates(false, ['人员']);
          },
        },
      ],
    };
  },
  /**
   * 用来封装计算属性 有缓存功能  类似于computed
   */
  getters: {},
  /**
   * 编辑业务逻辑  类似于methods
   */
  actions: {
    selOpenFloor(index) {
      if (this.floorData.selIndex !== index) {
        this.floorData.selIndex = index;
        HC.CameraControl.CmdMoveCamera(this.floorData.data[this.floorData.selIndex].camera);
        HC.eventControl.CmdDrawBuilding(this.floorData.data[this.floorData.selIndex].id);
      }
    },
    changeTimeLine(index) {
      if (this.timeLine.index !== index) {
        this.timeLine.index = index;
        HC.eventControl.CmdPlayActionByFileName(this.timeLine.data[this.timeLine.index].content);
      }
    },
  },
});
